<script>
  import {
    VNavigationDrawer
  } from 'vuetify/lib'
  export default {
    name: 'wh-drawer',
    extends: VNavigationDrawer
  };
</script>